<template>
  <publicPage />
</template>

<script setup>
import publicPage from "./components/publicPage";

// 设置TDK
useHead({
  title: `廉洁建设 - 郑州路桥建设投资集团有限公司`,
})
</script>

<style scoped>

</style>